<template lang="pug">
  main.home(v-if="settings")
    header.header
      main-menu
      carousel(
        :perPage="1"
        :autoplay="true"
        :autoplayHoverPause="true"
        :loop="true"
        :autoplayTimeout="6000"
        paginationColor="#f8f8f8"
        paginationActiveColor="#5477a3"
      )
        slide(
          v-for="(slide, index) in settings.sections.home.carousel"
          :key="index"
          :style="`background-image:url(${slide})`"
        )
    section.section(v-if="home_data")
      div.container
        div
          div.quote
            h1 {{ settings.sections.home.quote.text }}
            p  {{ settings.sections.home.quote.author }}
          div.tweets
            div.tweets--title
              h2 Latest
              h1 tweets
            vue-scrollbar.tweets--wrapp(ref="scrollbar")
              div
                div.tweet--item(v-for="tweet in tweets" v-html="tweet")
            div.tweets--actions
              a(href="https://twitter.com/OGS_MAOS" target="new") View on Twitter
        div.intro
          h3 MAOS GROUP
          h1.title {{ settings.sections.about.subtitle }}
          p {{ settings.sections.about.description }}
            span
              router-link(to="about" class="read-more") Read more
      div.map
        div.map__wrapp
          v-map(
            ref="map"
            :zoom="zoom"
            :center="center"
            :options="options"
          )
            v-tilelayer(
              :url="url"
            )
            v-geojson-layer(
              v-if="home_markers"
              ref="markers"
              :geojson="home_markers"
              :options="markers_options"
            )
        div.live-data.container
          h1 active instruments
          p.live last update
            span  {{ lastupdate }}
          table(v-if="home_data.totale_boe")
            tr
              td
                div(class="boe-icon drifter")
                  span {{ home_data.totale_boe.drifter }}
                  span Drifters
            tr
              td
                div(class="boe-icon float")
                  span {{ home_data.totale_boe.float }}
                  span Floats
            tr
              td
                div(class="boe-icon glider")
                  span {{ home_data.totale_boe.glider }}
                  span Gliders
        div.tabs(v-if="home_data.boe_per_oceano_last_month")
          div(@click="locationsChoice('5')")
            h1 {{ home_data.boe_per_oceano_last_month['5'].area }}
            h2 {{ home_data.boe_per_oceano_last_month['5'].sum }}
              span  Total Instruments
            a(class="read-more" v-if="home_data.boe_per_oceano_last_month['5'].sum !== '0'")
              span View on Map
          div(@click="locationsChoice('18')")
            h1 {{ home_data.boe_per_oceano_last_month['18'].area }}
            h2 {{ home_data.boe_per_oceano_last_month['18'].sum }}
              span  Total Instruments
            a(class="read-more" v-if="home_data.boe_per_oceano_last_month['18'].sum !== '0'")
              span View on Map
          div(@click="locationsChoice('2')")
            h1 {{ home_data.boe_per_oceano_last_month['2'].area }}
            h2 {{ home_data.boe_per_oceano_last_month['2'].sum }}
              span  Total Instruments
            a(class="read-more" v-if="home_data.boe_per_oceano_last_month['2'].sum !== '0'")
              span View on Map
          div(@click="locationsChoice('19')")
            h1 {{ home_data.boe_per_oceano_last_month['19'].area }}
            h2 {{ home_data.boe_per_oceano_last_month['19'].sum }}
              span  Total Instruments
            a(class="read-more" v-if="home_data.boe_per_oceano_last_month['19'].sum !== '0'")
              span View on Map
      div.instruments
        div.container
          h1 instruments
          div.tiles(v-if="home_data.instruments_drifters")
            router-link(to="/instruments/drifters")
              h1 Drifters
              img(src="../assets/home-instrument-drifters.jpg" width="360" height="188")
              p {{ home_data.instruments_drifters.description | distilled }} ...
              router-link(to="/instruments/drifters") read more
            router-link(to="/instruments/floats")
              h1 Floats
              img(src="../assets/home-instrument-floats.jpg" width="360" height="188")
              p {{ home_data.instruments_floats.description | distilled }} ...
              router-link(to="/instruments/floats") read more
            router-link(to="/instruments/gliders")
              h1 Gliders
              img(src="../assets/home-instrument-gliders.jpg" width="360" height="188")
              p {{ home_data.instruments_gliders.description | distilled }} ...
              router-link(to="/instruments/gliders") read more
      div.wrapper.container
        div.projects(v-if="home_data.ultimi_progetti")
          div
            h2 latest
            h1 projects
            router-link(to="projects")
          div.project(v-for="(project, index) in home_data.ultimi_progetti" :key="`project-${index}`")
            router-link(:to="`projects/${project.id_project}`")
              span {{ project.name }} - {{ yearDate(project.date_start) }}
              span.locations
                i.separator /
                | {{ project.location_name }}
            p {{ project.total || 0 }}
              span  total instruments
            router-link(:to="`projects/${project.nome_www}`" class="project-info")
              span Project Info
            a(@click="viewMap(project)")
              span View on Map
</template>

<script>
import moment from 'moment'
import TwitterFetcher from 'twitter-fetcher'
import MainMenu from '@/components/MainMenu.vue'
import { mapState } from 'vuex'
import L from 'leaflet'
import Vue2Leaflet from 'vue2-leaflet'
import VueScrollbar from 'vue2-scrollbar'

import { Carousel, Slide } from 'vue-carousel'

const MARKERICON = function () {
  return L.divIcon({
    iconSize: [4, 4],
    iconAnchor: [0, 0],
    shadowSize: [0, 0],
    className: 'marker-home'
  })
}

export default {
  name: 'home',
  metaInfo: {
    title: 'Home'
  },
  components: {
    'main-menu': MainMenu,
    'v-map': Vue2Leaflet.Map,
    'v-tilelayer': Vue2Leaflet.TileLayer,
    'v-geojson-layer': Vue2Leaflet.GeoJSON,
    Carousel,
    Slide,
    VueScrollbar
  },
  computed: {
    ...mapState({
      home_markers: 'home_markers',
      home_data: 'home_data',
      mapFilters: 'mapFilters',
      settings: 'settings'
    })
  },
  data () {
    return {
      tweets: [],
      lastupdate: moment().format('DD/MM/YYYY'),
      url: 'https://api.mapbox.com/styles/v1/interfase/cjchvpnzl6ik22smxy02yhhmw/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaW50ZXJmYXNlIiwiYSI6ImNqZXh4ZTJpazBuajIyd3FtMXJ5eXFrNWQifQ.1B5bViv06ehjgrlidVMqOw',
      zoom: 5,
      center: [42.17, 13.12],
      options: {
        dragging: false,
        scrollWheelZoom: false,
        zoomControl: false,
        doubleClickZoom: false
      },
      markers_options: {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {icon: MARKERICON()})
        }
      }
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_HOME_MARKERS')
    this.$store.dispatch('LOAD_LOCATIONS_LIST')
    this.$store.dispatch('LOAD_PROJECT_LIST')

    this.fetch()
  },
  updated () {
    this.$refs.scrollbar.calculateSize()
  },
  methods: {
    yearDate: function (date) {
      return date ? moment(date).format('Y') : ''
    },
    fetch: function () {
      const LatestTweets = {
        'profile': {'screenName': 'OGS_MAOS'},
        'customCallback': this.setTweets,
        'maxTweets': 6,
        'enableLinks': true,
        'showUser': false,
        'showTime': true,
        'dateFunction': this.dateFormatter,
        // 'showRetweet': false,
        'showInteraction': false,
        'showImages': false
      }
      TwitterFetcher.fetch(LatestTweets)
    },
    setTweets (tweets) {
      this.tweets = tweets
    },
    dateFormatter (date) {
      let customDate = date.toLocaleDateString()
      customDate = customDate.replace(/\//g, '/')
      customDate = customDate.split(/(?=.{6}$)/).join('<span class="month">')
      customDate = customDate.split(/(?=.{4}$)/).join('</span>')
      return customDate
    },
    locationsChoice (id) {
      const boe = parseInt(this.home_data.boe_per_oceano_last_month[id].sum, 10)
      if (boe > 0) {
        this.$store.commit('SET_MAP_FILTERS', {
          location: id,
          dateFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          dateTo: moment().format('YYYY-MM-DD'),
          nationality: 'ITALY'
        })
        this.$router.push({ path: 'data' })
      }
    },
    viewMap (prj) {
      this.$store.dispatch('LOAD_PROJECT', prj.id_project)
      this.$store.commit('SET_MAP_FILTERS', {
        location: prj.multipleLocations ? null : parseInt(prj.location, 10),
        dateFrom: prj.date_start,
        dateTo: prj.date_end_phy || moment().format('YYYY-MM-DD'),
        project: prj.id_project
      })
      this.$router.push({ path: '/data' })
    }
  },
  filters: {
    distilled: function (value) {
      // strip html and truncate string
      return value.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 150)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.map__wrapp {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue